import React, { ChangeEventHandler, ReactNode } from 'react';
import {
  Textarea as MantineTextarea,
  type MantineSize,
  MantineStyleProps,
  type TextareaProps,
} from '@mantine/core';
import textareaClasses from './Textarea.module.css';

type Props = {
  id?: string;
  required?: boolean;
  withAsterisk?: boolean;
  label?: string;
  description?: ReactNode;
  inputWrapperOrder?: TextareaProps['inputWrapperOrder'];
  placeholder?: string;
  disabled?: boolean;
  name?: string;
  onChange?: ChangeEventHandler<HTMLTextAreaElement> | undefined;
  value?: string;
  error?: React.ReactNode;
  rightSection?: ReactNode;
  autoFocus?: boolean;
  autosize?: boolean;
  minRows?: number;
  maxRows?: number;
  maxLength?: number;
  size?: MantineSize;
  styles?: TextareaProps['styles'];
} & MantineStyleProps;

export default function Textarea({
  id,
  required,
  withAsterisk,
  label,
  placeholder,
  disabled,
  name,
  onChange,
  value,
  error,
  rightSection,
  autoFocus,
  ...props
}: Props) {
  return (
    <MantineTextarea
      id={id}
      required={required}
      withAsterisk={withAsterisk}
      label={label}
      placeholder={placeholder}
      disabled={disabled}
      name={name}
      onChange={onChange}
      classNames={textareaClasses}
      value={value}
      error={error}
      rightSection={rightSection}
      autoFocus={autoFocus}
      {...props}
    />
  );
}
